import Alarm from "./Alarm";

export default class AlarmRadio extends Alarm {
	constructor(data) {
		super(data);
		this.radius = data.radius ? data.radius : 0;
		this.type_alarm = data.type_alarm ? data.type_alarm : 1;
	}
}
